import type { CSSProperties } from 'react';
import type { CSSObject } from '@emotion/react';
import { useClassName } from './useClassName';
import { styleRule } from './styleRule';
import { LooseProps } from './props';

const overlay: CSSObject = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 1200,
};

export function Drawer(props: LooseProps) {
  const { open, onClose, anchor = 'left', children, slotProps } = props;
  const {
    className: paperClass,
    css,
    styleId,
  } = useClassName(slotProps?.paper?.sx, {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: anchor === 'left' ? 0 : undefined,
    right: anchor === 'left' ? undefined : 0,
    zIndex: 1201,
    backgroundColor: '#121212',
    color: '#fff',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
  });
  if (!open) return null;
  return (
    <div>
      {styleRule(styleId, css)}
      <div onClick={onClose} style={overlay as CSSProperties} />
      <div className={paperClass}>{children}</div>
    </div>
  );
}
